module.exports = "<ng-transclude ng-click=\"$ctrl.select()\"></ng-transclude>\n"